import { ApiResult, HttpClient } from "../http.js";
import {
  BlueprintCreditsDto,
  CheckoutSessionDto,
  CreditLedgerEntryDto,
} from "../types/blueprintCredits.js";

export class BlueprintCreditsApi {
  constructor(private readonly http: HttpClient) {}

  get(): Promise<ApiResult<BlueprintCreditsDto>> {
    return this.http.get<BlueprintCreditsDto>("/api/blueprint-credits");
  }

  ledger(): Promise<ApiResult<CreditLedgerEntryDto[]>> {
    return this.http.get<CreditLedgerEntryDto[]>("/api/blueprint-credits/ledger");
  }

  checkout(priceId: string): Promise<ApiResult<CheckoutSessionDto>> {
    return this.http.post<CheckoutSessionDto>("/api/blueprint-credits/checkout", {
      body: { priceId },
    });
  }
}
